"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = tag;
/* eslint-disable */
function tag(tagName, extendsElement) {
    return (constructor) => {
        let options = {};
        if (extendsElement) {
            options.extends = extendsElement;
        }
        window.customElements.define(tagName, constructor, options);
    };
}
//# sourceMappingURL=Tag.js.map